module.exports = __webpack_public_path__ + "facebook.d979597c0cbc7a92cf35c00f625e7687.svg";